import React from "react"
import { IconButton, Badge, CircularProgress, Drawer} from "@mui/material"
import MenuIcon from "@mui/icons-material/Menu"
import CloseIcon from "@mui/icons-material/Close"
import CachedIcon from "@mui/icons-material/Cached"
import ArrowBackIcon from "@mui/icons-material/ArrowBack"
import PlayArrowIcon from "@mui/icons-material/PlayArrow"
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown"
import NotificationsIcon from "@mui/icons-material/Notifications"

import { HomepageNavigationItems, DashboardNavigationItems } from "../../config/nav"
import { Actions, useDispatch, useSelector } from "../../stores/dashboard.store"

import Logo from "../logo/logo"

import styles from "./styles.module.css"

function MobileProjectsNav({
    Component,
    user,
    projectMenu,
    openNotificationsMenu,
    notificationsRefMenu,
    hideNotifications,
    activeNotificationsCount,
    accountMenuRef,
    navItems,
    dashboardView,
    setActivePage,
    hasUnfulfilledNodes,
    activeProjectRequiresSave,
    isTaskQueued,
    isTaskLoading,
    drawerOpen,
    setDrawerOpen
}) {
    const dispatch = useDispatch()
    const { activeProject, dashboardNavigation } = useSelector()

    return (
        <div className={styles.page}>
            <div className={styles.navBody}>
                <div
                    className={styles.actionGroup}
                    style={{
                        position: "absolute",
                        top: 0,
                        left: 100,
                        zIndex: 1,
                        display: drawerOpen ? "none" : "block",
                    }}
                >
                    <div className={styles.innerButtonBar}>
                        <IconButton onClick={() => setDrawerOpen(!drawerOpen)}>
                            <MenuIcon style={{color: 'var(--text-primary)'}} />
                        </IconButton>
                    </div>
                </div>

                <div className={styles.pageContent}>
                    <Component />
                </div>

                <Drawer
                    disableEnforceFocus
                    keepMounted
                    anchor="left"
                    variant="temporary"
                    open={drawerOpen}
                    onClose={() => setDrawerOpen(false)}
                    style={{ zIndex: 992,  }}
                    PaperProps={{ style: { width: "100%", backgroundColor: "var(--background-primary)" } }}
                >
                    <CloseIcon
                        style={{ position: "absolute", top: 10, right: 10, cursor: "pointer", color:'var(--text-primary)' }}
                        onClick={() => setDrawerOpen(false)}
                    />

                    {dashboardNavigation !== HomepageNavigationItems._id &&
                        <IconButton style={{ position: "absolute", top: 8, left: 10, cursor: "pointer", color: 'var(--text-primary)' }} onClick={() => {
                            setDrawerOpen(false)
                            dispatch(Actions.NavigateDashboard, {
                                nav: HomepageNavigationItems._id,
                                view: HomepageNavigationItems.ProjectList,
                            })
                        }}>
                            <ArrowBackIcon />
                        </IconButton>
                    }

                    <div className={styles.orgStructure}>
                        <Logo />
                    </div>
                    {navItems?._changeOrg && (
                        <div
                            style={{
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                margin: "10px",
                                color: "var(--text-primary)",
                            }}
                            ref={projectMenu.ref}
                            onClick={projectMenu.handleClick}
                        >
                            {activeProject?.name}
                            <ArrowDropDownIcon style={{ color: "var(--text-dim)" }} />
                        </div>
                    )}

                    {user?.at === "dev" && (
                        <div
                            style={{
                                justifyContent: "center",
                                display: "flex",
                                alignItems: "center",
                            }}
                        >
                            <div className={styles.badge}>Test Mode</div>
                        </div>
                    )}

                    {navItems?._showBack && (
                        <div
                            className={styles.backButton}
                            onClick={() =>
                                dispatch(Actions.NavigateDashboard, {
                                    nav: DashboardNavigationItems._id,
                                    view: DashboardNavigationItems.Request,
                                })
                            }
                        >
                            <ArrowBackIcon />
                            <div>Back</div>
                        </div>
                    )}

                    <div className={styles.sidebarGroup}>
                        {Object.keys(navItems)
                            .filter((key) => !key.startsWith("_"))
                            .map((key) => {
                                const page = navItems[key]
                                if (!page?._show) return null
                                if(page?._requiresDeveloper === true && user?.is_developer === false) return null

                                return (
                                    <div
                                        key={page.id}
                                        onClick={() => {
                                            setDrawerOpen(false)
                                            setActivePage(page)
                                        }}
                                        className={
                                            dashboardView?.id === page?.id
                                                ? styles.sidebarItemActive
                                                : styles.sidebarItem
                                        }
                                    >
                                        <page.Icon />
                                        {key}
                                    </div>
                                )
                            })}
                    </div>

                    {navItems?._showRun && (
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                marginTop: "auto",
                                alignItems: "center",
                                gap: 2,
                                padding: 10,
                            }}
                        >
                            <button
                                className={styles.runButton}
                                disabled={hasUnfulfilledNodes ||
                                    activeProjectRequiresSave ||
                                    isTaskQueued ||
                                    isTaskLoading ||
                                    activeProject?.nodes?.length === 0}
                                onClick={() => {
                                    setDrawerOpen(false)
                                    dispatch(Actions.SetShowRunDialog, true)
                                }}
                            >
                                <div style={{ color: "white", textTransform: "none" }}>
                                    {isTaskLoading ? "Loading" : isTaskQueued ? "Queued" : "Run"}
                                </div>
                                {isTaskLoading ? (
                                    <CircularProgress size={20} />
                                ) : isTaskQueued ? (
                                    <CachedIcon
                                        fontSize="small"
                                        className={styles.spinningIcon}
                                        style={{ color: "white" }}
                                    />
                                ) : (
                                    <PlayArrowIcon fontSize="small" style={{ color: "white" }} />
                                )}
                            </button>
                        </div>
                    )}

                    <div style={{ paddingBottom: "80px" }}>
                        <div
                            style={{ position: "fixed", bottom: 0, left: 0, width: "100%" }}
                        >
                            <hr style={{ color: "gray", backgroundColor: "gray", width: "100%" }} />
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 25,
                                    justifyContent: "center",
                                    margin: "5px",
                                }}
                            >
                                <div ref={notificationsRefMenu?.ref} onClick={openNotificationsMenu}>
                                    <IconButton>
                                        <Badge
                                            color="#bbb"
                                            badgeContent={hideNotifications ? 0 : activeNotificationsCount}
                                            sx={{
                                                "& .MuiBadge-badge": {
                                                    color: "white",
                                                    backgroundColor: "grey",
                                                },
                                            }}
                                        >
                                            <NotificationsIcon style={{ color: "var(--text-dim)" }} />
                                        </Badge>
                                    </IconButton>
                                </div>
                                <div
                                    className={styles.accountName}
                                    ref={accountMenuRef?.ref}
                                    onClick={() => accountMenuRef.setShow(true)}
                                >
                                    <div style={{ display: "flex", alignItems: "center" }}>
                                        {user?.name?.split(" ")[0]}
                                    </div>
                                    <ArrowDropDownIcon style={{ color: "var(--text-dim)" }} />
                                </div>
                            </div>
                        </div>
                    </div>
                </Drawer>
            </div>


        </div>
    )
}

export default MobileProjectsNav